import { OverflowMenu } from 'ui/actionMenu';
import { useHistory } from 'react-router';
import { AllowedActionMenuElements, ActionMenuOption } from 'ui/actionMenu/types';
import { SystemWebhooksActionButtonProps } from '../types';

export const SystemWebhooksActionButton = ({
  webhook,
  openDeleteModal,
}: SystemWebhooksActionButtonProps) => {
  const history = useHistory();

  const editId = 'edit-system-webhook';
  const archiveId = 'delete-system-webhook';

  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <span>Edit</span>
        </>
      ),
      id: editId,
      onClick: () => history.push(`/integrations/webhooks/${webhook.id}/edit`),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <span>Delete</span>
        </>
      ),
      id: archiveId,
      onClick: () => openDeleteModal(webhook.id),
    },
  ];

  return (
    <OverflowMenu
      id="system-webhooks-table-overflow-menu"
      data-test="system-webhooks-table-actions-button"
      options={options}
    />
  );
};
